import type { AxiosError } from "axios";

export function getApiErrorMessage(error: unknown, fallback = "Something went wrong") {
  const axiosError = error as AxiosError<{ message?: string; title?: string }>;
  return axiosError.response?.data?.message
    ?? axiosError.response?.data?.title
    ?? axiosError.message
    ?? fallback;
}
